// Proline Commercial Management System - Shared Styles

export const C = {
  header: '#000000',
  sidebar: '#000000',
  accent: '#000000',
  accentHover: '#000000',
  bg: '#f5f5f5',
  card: '#ffffff',
  text: '#111111',
  textMuted: '#6b7280',
  textLight: '#9ca3af',
  border: '#e5e7eb',
  borderDark: '#d1d5db',
  danger: '#dc2626',
  dangerLight: '#fef2f2',
  dangerBorder: '#fecaca',
  success: '#16a34a',
  successLight: '#f0fdf4',
  successBorder: '#bbf7d0',
  warning: '#d97706',
  warningLight: '#fffbeb',
  warningBorder: '#fde68a',
  // Status colors
  status: {
    draft: '#6b7280',
    draftBg: '#f3f4f6',
    submitted: '#d97706',
    submittedBg: '#fffbeb',
    pending: '#d97706',
    pendingBg: '#fffbeb',
    signed: '#16a34a',
    signedBg: '#f0fdf4',
    confirmed: '#16a34a',
    confirmedBg: '#f0fdf4',
    agreed: '#16a34a',
    agreedBg: '#f0fdf4',
    disputed: '#dc2626',
    disputedBg: '#fef2f2',
    open: '#3b7dd8',
    openBg: '#eff6ff',
    priced: '#7c3aed',
    pricedBg: '#f5f3ff',
    daywork: '#0891b2',
    dayworkBg: '#ecfeff',
    closed: '#374151',
    closedBg: '#f9fafb',
    partAgreed: '#d97706',
    partAgreedBg: '#fffbeb',
    na: '#9ca3af',
    naBg: '#f9fafb',
    mcNotified: '#1d4ed8',
    mcNotifiedBg: '#dbeafe',
    sentToMc: '#9d174d',
    sentToMcBg: '#fce7f3',
    irRaised: '#065f46',
    irRaisedBg: '#d1fae5',
    dayworksInProgress: '#0891b2',
    dayworksInProgressBg: '#ecfeff',
    variationSubmitted: '#7c3aed',
    variationSubmittedBg: '#f5f3ff',
  }
};

export const S = {
  // Layout
  pageContainer: {
    padding: '24px',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
    flexWrap: 'wrap',
    gap: '12px',
  },
  pageTitle: {
    fontSize: '20px',
    fontWeight: '500',
    color: C.text,
    margin: 0,
  },
  // Cards
  card: {
    background: C.card,
    borderRadius: '8px',
    padding: '24px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    border: `1px solid ${C.border}`,
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
  },
  cardTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: C.text,
    margin: 0,
  },
  // Grid
  grid2: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: '16px',
  },
  grid3: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
    gap: '16px',
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
    gap: '16px',
    marginBottom: '24px',
  },
  // Table
  tableWrapper: {
    overflowX: 'auto',
    borderRadius: '8px',
    border: `1px solid ${C.border}`,
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '14px',
  },
  th: {
    background: '#f9fafb',
    padding: '10px 16px',
    textAlign: 'left',
    fontWeight: '600',
    color: C.textMuted,
    fontSize: '12px',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    borderBottom: `1px solid ${C.border}`,
    whiteSpace: 'nowrap',
  },
  td: {
    padding: '12px 16px',
    borderBottom: `1px solid ${C.border}`,
    color: C.text,
    verticalAlign: 'middle',
  },
  trHover: {
    cursor: 'pointer',
  },
  // Buttons
  btn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '8px 16px',
    borderRadius: '6px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'opacity 0.15s',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
  },
  btnPrimary: {
    background: C.accent,
    color: '#fff',
  },
  btnDanger: {
    background: C.danger,
    color: '#fff',
  },
  btnSuccess: {
    background: C.success,
    color: '#fff',
  },
  btnWarning: {
    background: C.warning,
    color: '#fff',
  },
  btnOutline: {
    background: 'transparent',
    color: C.accent,
    border: `1px solid ${C.accent}`,
  },
  btnGhost: {
    background: 'transparent',
    color: C.textMuted,
    border: `1px solid ${C.border}`,
  },
  btnSm: {
    padding: '5px 10px',
    fontSize: '12px',
  },
  btnLg: {
    padding: '12px 24px',
    fontSize: '16px',
  },
  // Form elements
  formGroup: {
    marginBottom: '16px',
  },
  label: {
    display: 'block',
    marginBottom: '6px',
    fontWeight: '500',
    fontSize: '14px',
    color: C.text,
  },
  input: {
    width: '100%',
    padding: '9px 12px',
    borderRadius: '6px',
    border: `1px solid ${C.borderDark}`,
    fontSize: '14px',
    color: C.text,
    background: '#fff',
    boxSizing: 'border-box',
    outline: 'none',
  },
  textarea: {
    width: '100%',
    padding: '9px 12px',
    borderRadius: '6px',
    border: `1px solid ${C.borderDark}`,
    fontSize: '14px',
    color: C.text,
    background: '#fff',
    boxSizing: 'border-box',
    resize: 'vertical',
    outline: 'none',
    minHeight: '80px',
  },
  select: {
    width: '100%',
    padding: '9px 12px',
    borderRadius: '6px',
    border: `1px solid ${C.borderDark}`,
    fontSize: '14px',
    color: C.text,
    background: '#fff',
    boxSizing: 'border-box',
    outline: 'none',
    cursor: 'pointer',
  },
  // Badges
  badge: {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: '12px',
    fontSize: '11px',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  },
  // Alerts
  alertError: {
    padding: '12px 16px',
    borderRadius: '6px',
    background: C.dangerLight,
    border: `1px solid ${C.dangerBorder}`,
    color: C.danger,
    fontSize: '14px',
    marginBottom: '16px',
  },
  alertSuccess: {
    padding: '12px 16px',
    borderRadius: '6px',
    background: C.successLight,
    border: `1px solid ${C.successBorder}`,
    color: C.success,
    fontSize: '14px',
    marginBottom: '16px',
  },
  alertWarning: {
    padding: '12px 16px',
    borderRadius: '6px',
    background: C.warningLight,
    border: `1px solid ${C.warningBorder}`,
    color: C.warning,
    fontSize: '14px',
    marginBottom: '16px',
  },
  alertInfo: {
    padding: '12px 16px',
    borderRadius: '6px',
    background: '#f0f0f0',
    border: '1px solid #d1d5db',
    color: '#222222',
    fontSize: '14px',
    marginBottom: '16px',
  },
  // Tabs
  tabBar: {
    display: 'flex',
    borderBottom: `2px solid ${C.border}`,
    marginBottom: '24px',
    gap: '0',
    overflowX: 'auto',
  },
  tab: {
    padding: '10px 20px',
    cursor: 'pointer',
    fontWeight: '500',
    fontSize: '14px',
    border: 'none',
    background: 'none',
    color: C.textMuted,
    borderBottom: '2px solid transparent',
    marginBottom: '-2px',
    whiteSpace: 'nowrap',
    transition: 'color 0.15s',
  },
  tabActive: {
    color: C.accent,
    borderBottom: `2px solid ${C.accent}`,
  },
  // Divider
  divider: {
    border: 'none',
    borderTop: `1px solid ${C.border}`,
    margin: '16px 0',
  },
  // Empty state
  emptyState: {
    textAlign: 'center',
    padding: '48px 24px',
    color: C.textMuted,
  },
  emptyStateIcon: {
    fontSize: '48px',
    marginBottom: '12px',
  },
  emptyStateText: {
    fontSize: '16px',
    marginBottom: '8px',
    fontWeight: '500',
  },
  emptyStateSubtext: {
    fontSize: '14px',
  },
  // Spinner
  spinner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '48px',
    color: C.textMuted,
    fontSize: '16px',
  },
  // Section header
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: C.text,
    margin: 0,
  },
  // Info row (label: value)
  infoRow: {
    display: 'flex',
    marginBottom: '8px',
    fontSize: '14px',
    gap: '8px',
    flexWrap: 'wrap',
  },
  infoLabel: {
    fontWeight: '600',
    color: C.textMuted,
    minWidth: '160px',
  },
  infoValue: {
    color: C.text,
    flex: 1,
  },
};

// Helper to get badge style for a status
export function getStatusBadgeStyle(status) {
  const statusKey = status ? status.toLowerCase().replace(/_/g, '') : '';
  const map = {
    draft: { background: C.status.draftBg, color: C.status.draft },
    submitted: { background: C.status.submittedBg, color: C.status.submitted },
    pending: { background: C.status.pendingBg, color: C.status.pending },
    signed: { background: C.status.signedBg, color: C.status.signed },
    confirmed: { background: C.status.confirmedBg, color: C.status.confirmed },
    agreed: { background: C.status.agreedBg, color: C.status.agreed },
    disputed: { background: C.status.disputedBg, color: C.status.disputed },
    open: { background: C.status.openBg, color: C.status.open },
    priced: { background: C.status.pricedBg, color: C.status.priced },
    daywork: { background: C.status.dayworkBg, color: C.status.daywork },
    closed: { background: C.status.closedBg, color: C.status.closed },
    partagreed: { background: C.status.partAgreedBg, color: C.status.partAgreed },
    na: { background: C.status.naBg, color: C.status.na },
    mcnotified: { background: C.status.mcNotifiedBg, color: C.status.mcNotified },
    senttom: { background: C.status.sentToMcBg, color: C.status.sentToMc },
    senttoc: { background: C.status.sentToMcBg, color: C.status.sentToMc },
    irraised: { background: C.status.irRaisedBg, color: C.status.irRaised },
    awaitinginstruction: { background: C.status.submittedBg, color: C.status.submitted },
    dayworksinprogress: { background: C.status.dayworksInProgressBg, color: C.status.dayworksInProgress },
    variationsubmitted: { background: C.status.variationSubmittedBg, color: C.status.variationSubmitted },
    qsreview: { background: '#fef3c7', color: '#92400e' },
    false: { background: C.status.draftBg, color: C.status.draft },
    true: { background: C.status.signedBg, color: C.status.signed },
  };
  return map[statusKey] || { background: C.status.draftBg, color: C.status.draft };
}

// Format currency
export function formatValuationBasis(value) {
  const map = {
    contract_rates: 'Contract Rates',
    new_rates: 'New Rates',
    fair_valuation: 'Fair Valuation',
    dayworks: 'Dayworks',
    mixed: 'Mixed',
  };
  return map[value] || (value ? value.replace(/_/g, ' ') : '—');
}

export function formatCurrency(value) {
  if (value === null || value === undefined || value === '') return '—';
  return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(value);
}

// Format hours without trailing zeros: 8 → "8", 8.5 → "8.5", 8.25 → "8.25"
export function fmtHours(n) {
  return String(+n.toFixed(2));
}

// Format date DD/MM/YYYY
export function formatDate(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString('en-GB');
}

// Format datetime DD/MM/YYYY HH:MM
export function formatDateTime(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString('en-GB') + ' ' + d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
}

// Calculate hours between two HH:MM strings
export function calcHours(start, finish) {
  if (!start || !finish) return 0;
  const [sh, sm] = start.split(':').map(Number);
  const [fh, fm] = finish.split(':').map(Number);
  const startMins = sh * 60 + sm;
  const finishMins = fh * 60 + fm;
  if (finishMins <= startMins) return 0;
  return (finishMins - startMins) / 60;
}
